<template>
    <div>
      
        <div class="text-h5 px-4">

        Оплата
        
        </div>


        <div class="px-4">Квитанция л/с 100500 за Ноябрь 2020</div>

        <v-list-item>
   <!--         <v-list-item-icon>
               <v-icon>mdi-information-outline</v-icon>
           </v-list-item-icon> -->

          <v-list-item-content>
              <v-list-item-title>
                  Платежная информация
              </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
              <v-btn icon>
                  <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
          </v-list-item-action>
        </v-list-item>

             <v-divider class="ml-4"/>



        <v-text-field class="px-4" label="Номер телефона" persistent-hint/>
      
        <div class="text-right px-4">
            <div class="text-body-1">Итого к оплате:</div>
            <div  class="text-h4">2459.00</div>
            <div class="caption grey--text">включая вознаграждение: 59.00</div>
        </div>




        <v-footer app>
            <v-btn style="margin-bottom: 38px" color="primary" block depressed>К ОПЛАТЕ</v-btn>
        </v-footer>
        


    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>